<section class="lk-summary" data-test-id="locks-keys-summary-section">
  <h4 class="lk-summary__title">
    <span class="lk-summary__title-text">
      {{ t('summary.title') }}
      <button type="button" class="lk-summary__info"
              [attr.aria-label]="t('panel.introButton')"
              [title]="t('panel.introButton')"
              data-test-id="locks-keys-summary-intro"
              (click)="openIntro()">
        <i class="fas fa-circle-info" aria-hidden="true"></i>
      </button>
    </span>
  </h4>

  <!-- Tweeluik-periodekeuze: deelt de bewaarde keuze met de modus en de chart-overlay. -->
  <hd-locks-keys-period-pair-toggle
    class="lk-summary__period"
    size="xs"
    testId="locks-keys-summary-period"
  ></hd-locks-keys-period-pair-toggle>

  @if (bornAfterShift()) {
    <!-- Geboorte vanaf de globale shift (15-02-2027): 19/49 vormt geen kanaal meer. -->
    <div class="lk-summary__post-shift" data-test-id="locks-keys-summary-post-shift">
      <i class="fas fa-seedling" aria-hidden="true"></i>
      <span class="lk-summary__post-shift-text">{{ t('summary.postShiftNote') }}</span>
      <button type="button" class="lk-summary__post-shift-link"
              data-test-id="locks-keys-summary-post-shift-link"
              (click)="openPostShift()">
        {{ t('summary.postShiftLink') }}
      </button>
    </div>
  }

  @let personBadge = badge();
  <div class="lk-summary__badge" [attr.data-kind]="personBadge.kind" [title]="personBadge.tooltip"
       data-test-id="locks-keys-summary-badge">
    <i class="fas fa-lock-keyhole" aria-hidden="true"></i>
    @if (personBadge.together) {
      <span class="lk-summary__badge-together">{{ t('panel.personBadgeTogether') }}:</span>
    }
    <span class="lk-summary__badge-label">{{ personBadge.label }}</span>
    <span class="lk-summary__badge-counts">{{ personBadge.counts }}</span>
  </div>

  @if (rows().length > 0) {
    <!-- Grid i.p.v. tabel: de key-kolom groeit mee met het aantal planeten en de
         rol krijgt de rest (met ellipsis), ook in een smalle dock. -->
    <div class="lk-summary__list">
      <div class="lk-summary__head" aria-hidden="true">
        <span>{{ t('panel.lockHeader') }}</span>
        <span>{{ t('summary.keyHeader') }}</span>
      </div>
      @for (row of rows(); track row.lockGate) {
        <button type="button" class="lk-summary__row"
                [title]="t('panel.lockRowTooltip')"
                [attr.data-test-id]="'locks-keys-summary-row-' + row.lockGate"
                (click)="openLockDetail(row.lockGate)">
          <span class="lk-summary__lock">
            <span class="lk-summary__lock-chip"
                  [class.is-muted]="!row.lockActivated"
                  [attr.title]="row.lockTooltip">
              <i class="fas fa-lock" aria-hidden="true"></i>
              {{ row.lockGate }}
            </span>
            @if (row.lockPlanets.length > 0) {
              <span class="lk-summary__planets">
                @for (planet of row.lockPlanets; track planet.key) {
                  <span class="lk-summary__planet" [style.color]="planet.color">{{ planet.glyph }}</span>
                }
              </span>
            }
            <span class="lk-summary__role-wrap">
              <span class="lk-summary__role" [title]="row.theme">{{ row.role }}</span>
              @if (row.roleQualifier) {
                <span class="lk-summary__role-qualifier">{{ row.roleQualifier }}</span>
              }
            </span>
          </span>
          <span class="lk-summary__key" [title]="row.keyTooltip">
            <span class="lk-summary__key-chip" [class.is-active]="row.keyActivated">{{ row.keyGate }}</span>
            @if (row.keyActivated) {
              <span class="lk-summary__planets">
                @for (planet of row.keyPlanets; track planet.key) {
                  <span class="lk-summary__planet" [style.color]="planet.color">{{ planet.glyph }}</span>
                }
              </span>
            } @else {
              <i class="fas fa-key lk-summary__key-missing" aria-hidden="true"></i>
            }
          </span>
        </button>
      }
    </div>
  } @else {
    <p class="lk-summary__none">{{ t('summary.none') }}</p>
  }

  <!-- Drie-standen-toggle: uit → alle locks & keys → enkel chartactivaties. -->
  <hd-locks-keys-overlay-toggle class="lk-summary__overlay-toggle" />

  <button type="button" class="lk-summary__mode-button"
          data-test-id="locks-keys-summary-open-mode"
          (click)="requestMode()">
    <i class="fas fa-lock-keyhole" aria-hidden="true"></i>
    {{ t('summary.openMode') }}
  </button>

  <!-- Zelfde zoektocht als in het L&K-paneel, zonder de modus te openen. -->
  <hd-locks-keys-chart-search class="lk-summary__search"></hd-locks-keys-chart-search>
</section>
